import React, { useEffect, useRef, useState } from 'react';
import { Volume2, Square, Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import axios from 'axios';
import { useI18n } from '../i18n/I18nContext';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const cache = new Map();
let current = null;

// Speaker button: reads text aloud with the server's AI voice (generated once, then cached).
export default function SpeakButton({ text, lang, testid }) {
  const { t } = useI18n();
  const [state, setState] = useState('idle');
  const audioRef = useRef(null);

  useEffect(() => () => { if (audioRef.current) audioRef.current.pause(); }, []);

  const stop = () => { audioRef.current?.pause(); setState('idle'); };
  const play = async () => {
    if (state === 'playing') { stop(); return; }
    if (current && current !== audioRef.current) current.pause();
    setState('loading');
    try {
      const key = `${lang}|${text}`;
      let url = cache.get(key);
      if (!url) {
        const res = await axios.post(`${API}/tts`, { text, lang }, { responseType: 'blob' });
        url = URL.createObjectURL(res.data);
        cache.set(key, url);
      }
      const a = new Audio(url);
      audioRef.current = a; current = a;
      a.onended = () => setState('idle');
      a.onpause = () => setState('idle');
      await a.play();
      setState('playing');
    } catch (e) {
      setState('idle');
      toast.error(t('help.voiceFailed'));
    }
  };

  return (
    <button onClick={play} disabled={state === 'loading'} data-testid={testid}
      className="flex items-center gap-1.5 text-xs px-3 py-1.5 rounded-full transition-colors kmt-no-print shrink-0"
      style={{ border: '1px solid var(--kmt-gold)', color: state === 'playing' ? '#111' : 'var(--kmt-gold)', background: state === 'playing' ? 'var(--kmt-gold)' : 'transparent' }}
      aria-label={t('help.listen')}>
      {state === 'loading' ? <Loader2 size={13} className="animate-spin" /> : state === 'playing' ? <Square size={12} /> : <Volume2 size={14} />}
      {state === 'playing' ? t('help.stop') : t('help.listen')}
    </button>
  );
}
